export default __webpack_public_path__ + "static/media/add_record.2a36b451.png";